import {useQuery} from 'react-query';
import {getCreditPayAvailableAmounts} from './getCreditPayAvailableAmounts';

const useGetCreditPayAvailableAmounts = (enabled?: boolean) => {
  return useQuery(
    ['get-credit-pay-available-amounts'],
    () => getCreditPayAvailableAmounts(),
    {enabled: enabled ?? true},
  );
};

export default useGetCreditPayAvailableAmounts;
